import NavBar from "../Components/Common/navBar";
import ProductIcon from "../Components/Landing/productIcon";
import CompanyIcons from "../Components/CompanyIcons/companyIcons";
import Footer from "../Components/Common/footer";

import "./styles/landing.css";

const Landing = () => {
    return (	
        <div className="landingPage">
            <NavBar />
            <div className="landingPage-body">
                <div>
                    <img
                        src="/landingPageAssets/landingPageBanner.png"
                        alt="landingPageBanner"
                        className="landingPage-banner"
                    />
                </div>

                <div className="unique-designs">
                    <p>Unique</p>
                    <p>Designs</p>
                </div>

                <div className="landingPage-description">
                    Premier destination for design and product development. 
                    Our designs are meticulously created to captivate the eye and elevate the art of gifting.
                </div>
                
                <div className="product-icons">
                    <ProductIcon src="/Website-Icons-Color_Gift-Wrap.png" alt="Gift-Wrap" text="Gift Wrap" href='/product/wrap-and-ensembles'/>
                    <ProductIcon src="/Website-Icons-Color_Gift-Bag.png" alt="Gift-Bag" text="Gift Bag" href='/product/gift-bags'/>
                    <ProductIcon src="/Website-Icons-Color_Gift-Boxes.png" alt="Gift-Boxes" text="Gift Boxes" href='/product/gift-boxes'/>
                    <ProductIcon src="/Website-Icons-Color_Gift-Cards.png" alt="Gift-Cards" text="Gift Cards" href='/product/greeting-cards'/>
                    <ProductIcon src="/Website-Icons-Color_Party.png" alt="Party" text="Party" href='/product/partyware'/>
                    <ProductIcon src="/Website-Icons-Color_Gift-Bows.png" alt="Gift-Bows" text="Gift Bows" href='/product/gift-bows'/>
                    <ProductIcon src="/Website-Icons-Color_Cello-Gift-Wrap.png" alt="Cello-Gift-Wrap" text="Cello Wrap" href='/product/cello-gift-wrap'/>
                    <ProductIcon src="/Website-Icons-Color_Gift-Tags.png" alt="Gift-Tags" text="Gift Tags" href='/product/gift-tag'/>
                </div>

                <div className="landingPage-content">
                    <div>
                        <img
                            src="/landingPageAssets/landingPageLifeStyleImage.jpg"
                            alt="landingPageLifeStyleImage"
                            className="landingPageLifeStyleImage"
                        />
                    </div>

                    <div className="landingPage-text">
                        <div className="text-item">
                            <p className="title">High Quality Product</p>
                            <p className="description">
                                We have unique print finishes that transform the simple act of presenting a gift into a delightful experience.
                            </p>
                        </div>

                        <div className="text-item">
                            <p className="title">Competitive Prices</p>
                            <p className="description">
                                Our direct-to-factory model not only enhances our competitiveness but also provides exceptional value to our customers.
                            </p>
                        </div>

                        <div className="text-item">
                            <p className="title">Lasting Relationships</p>
                            <p className="description">
                                Our mission is to build lasting relationships with our customers by providing quality product and unique design.
                            </p>
                        </div>
                    </div> 
                </div>


                <CompanyIcons /> 
                <Footer />
            </div>
        </div>
    );
};

export default Landing;